import { useEffect, useRef } from "react";
import { useRefreshTokenMutation } from "features/auth/auth";
import { useAppSelector } from "features/store";

const REFRESH_INTERVAL_MS = 25 * 60 * 1000;

export function useTokenRefresh() {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const [refreshToken] = useRefreshTokenMutation();
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    if (!isAuthenticated) {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
      return;
    }

    const doRefresh = () => {
      refreshToken().catch(() => {
      });
    };

    intervalRef.current = setInterval(doRefresh, REFRESH_INTERVAL_MS);
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, [isAuthenticated, refreshToken]);
}
